import { FC } from 'react'
import {
  StyleCard,
  StyleContentWrapper,
  StyleImageWrapper,
  StylePriceTag,
  StyleTag,
} from './style'
import Typography from '@components/typography'
import Button from '@components/button'
import Row from '@components/row'
import Svg from '@components/svg'
import Image from '@components/image'
interface LabTestProps {
  type?: 'Normal' | 'Package'
  labTest: any
  title?: string
  outline?: boolean
}
const LabTestCard: FC<LabTestProps> = ({
  type = 'Normal',
  labTest,
  title = 'View details',
  outline = false,
}) => {
  const tags =
    type == 'Package'
      ? labTest?.packages?.map((item: any) => {
          return {
            value: item?.name,
          }
        })
      : [
          {
            value: labTest?.categories[0]?.category?.name,
            icon: 'plusHeart',
          },
          {
            value: labTest?.categories?.[0]?.sampleTypes?.[0]?.name,
          },

          {
            value: labTest?.infos?.expectedResultTime,
            icon: 'time',
          },
        ]
  return (
    <StyleCard>
      <StyleImageWrapper>
        <Image src={`${process.env.BUCKET_URL}/${labTest?.images[0]?.image}`} />
        <StylePriceTag>
          <Typography
            content={`Rs.${labTest?.infos?.price}`}
            tc="primary"
            size={14}
          />
        </StylePriceTag>
      </StyleImageWrapper>
      <StyleContentWrapper>
        <Typography content={labTest?.name} size={16} />
        <Row colGap={10}>
          {tags?.map((tag: any, index: number) => {
            return (
              <StyleTag key={index}>
                {!!tag?.icon && <Svg svg={tag?.icon} size={16} />}
                <Typography content={tag?.value} size={12} tc="placeholder" />
              </StyleTag>
            )
          })}
        </Row>
        <Button
          title={title}
          styleButton="width:100%"
          height={40}
          radius={12}
          data-cross-id={labTest?.id}
          outline={outline}
        />
      </StyleContentWrapper>
    </StyleCard>
  )
}

export default LabTestCard
